import { Component, OnInit } from '@angular/core';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';

@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.less'],
  standalone: false
})
export class MasterDataComponent implements OnInit {
  title: string;

  subscriptionManagementId: any;
  subscriptionFiscalYear: any;
  subscriptionPeriod: any;
  subscriptions: any[] = [];

  constructor(public defaults: DefaultValuesService) {
    this.title = `INCO: Master Data (${this.defaults.managementName})`;
  }

  ngOnInit(): void {
    this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { this.loadData() });
    this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() => { this.loadData() });
  }

  ngOnDestroy() {
    this.subscriptionManagementId.unsubscribe();
    this.subscriptionFiscalYear.unsubscribe();
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  loadData() {
    this.subscriptions.forEach(x => x.unsubscribe())
    this.title = `INCO: Master Data (${this.defaults.managementName})`;
  }
}
